const transformCmsMenusResponse = (data)=>data.map(({ type , node_id , object_id , url , parent_id , level , title , menu_title , target , css_classes , max_items_for_column , identifier =''  } = {})=>({
            id: node_id,
            entityId: type === 'category' ? parseInt(object_id) : object_id,
            parentId: parent_id,
            menuTitle: menu_title,
            title,
            type,
            url: type === 'group' || url === '#' ? null : url,
            level,
            target,
            cssClasses: css_classes,
            maxItemsForColumn: max_items_for_column,
            identifier
        }));
const transformCmsBlocksResponse = (data)=>data.map(({ content_id , idx , content , display_container , display_entity , display_selection_target , display_selection_type , listing_columns_spacing , listing_display_page , listing_display_position , listing_row_spacing  })=>({
            id: content_id,
            identifier: idx,
            content,
            layout: {
                display: {
                    container: display_container,
                    entity: display_entity,
                    selectionTarget: display_selection_target,
                    selectionType: display_selection_type
                },
                listing: {
                    displayPage: listing_display_page,
                    displayPosition: listing_display_position,
                    columnsSpacing: listing_columns_spacing || 1,
                    rowSpacing: listing_row_spacing || 1
                }
            }
        }));
const transformCmsPagesResponse = (data)=>data.map(({ content_id , title , url_key , content , content_heading , breadcrumbs_visible , css_class , css_style , header_type , heading_visible , meta_description , meta_keywords , meta_title , refilo_layout , refilo_template , og_data_image , robots  })=>({
            id: content_id,
            title,
            urlKey: url_key,
            content,
            contentHeading: content_heading,
            layout: {
                breadcrumbsVisible: breadcrumbs_visible,
                cssClass: css_class,
                cssStyle: css_style,
                headerType: header_type,
                headingVisible: heading_visible,
                type: refilo_layout,
                template: refilo_template || null
            },
            seoMeta: {
                title: meta_title || title,
                description: meta_description,
                keywords: meta_keywords || '',
                robots
            },
            ogData: {
                title: meta_title || title,
                description: meta_description || meta_title || title,
                image: og_data_image || null,
                url: null
            }
        }));
const transformMasterdataMetadata = (metadata)=>{
    const transformedAttributes = Object.assign({}, metadata);
    delete transformedAttributes.ct_id;
    delete transformedAttributes.title;
    delete transformedAttributes.identifier;
    delete transformedAttributes.description;
    delete transformedAttributes.breadcrumb;
    delete transformedAttributes.breadcrumb_prev_link;
    delete transformedAttributes.breadcrumb_prev_name;
    delete transformedAttributes.created_time;
    delete transformedAttributes.update_time;
    delete transformedAttributes.default_url;
    delete transformedAttributes.page_title;
    delete transformedAttributes.meta_title;
    delete transformedAttributes.meta_description;
    delete transformedAttributes.meta_keywords;
    delete transformedAttributes.meta_robots;
    delete transformedAttributes.og_title;
    delete transformedAttributes.og_url;
    delete transformedAttributes.og_description;
    delete transformedAttributes.og_image;
    delete transformedAttributes.og_type;
    delete transformedAttributes.reviews_enabled;
    delete transformedAttributes.reviews_default_status;
    delete transformedAttributes.search_enabled;
    delete transformedAttributes.layout;
    delete transformedAttributes.root_template;
    delete transformedAttributes.layout_update_xml;
    delete transformedAttributes.sitemap_enable;
    delete transformedAttributes.sitemap_frequency;
    delete transformedAttributes.sitemap_priority;
    delete transformedAttributes.default_status;
    delete transformedAttributes.visibility;
    delete transformedAttributes.default_import_identifier_name;
    delete transformedAttributes.default_import_identifier_value;
    delete transformedAttributes.refilo_layout;
    delete transformedAttributes.heading_visible;
    delete transformedAttributes.breadcrumbs_visible;
    delete transformedAttributes.header_type;
    delete transformedAttributes.css_class;
    delete transformedAttributes.css_style;
    delete transformedAttributes.entity_id;
    delete transformedAttributes.created_at;
    delete transformedAttributes.updated_at;
    delete transformedAttributes.url_key;
    delete transformedAttributes.robots;
    delete transformedAttributes.content_block_identifier;
    delete transformedAttributes.status;
    delete transformedAttributes.use_default_meta_title;
    delete transformedAttributes.use_default_description;
    delete transformedAttributes.use_default_keywords;
    delete transformedAttributes.use_default_og_title;
    delete transformedAttributes.use_default_og_description;
    delete transformedAttributes.use_default_og_url;
    delete transformedAttributes.use_default_og_type;
    delete transformedAttributes.use_default_og_image;
    return transformedAttributes;
};
const transformCmsMasterdataContentResponse = (data)=>data.map((item)=>({
            id: parseInt(item.metadata.entity_id),
            type: item.metadata.identifier,
            title: item.metadata.title,
            urlKey: item.metadata?.url_key?.replace(/^\/?/, '/'),
            contentBlockIdentifier: item.metadata.content_block_identifier || null,
            metadata: transformMasterdataMetadata(item.metadata),
            layout: {
                type: item.metadata.refilo_layout,
                headingVisible: item.metadata.heading_visible === '1',
                breadcrumbsVisible: item.metadata.breadcrumbs_visible === '1',
                headerType: item.metadata.header_type,
                cssClass: item.metadata.css_class,
                cssStyle: item.metadata.css_style
            },
            seoMeta: {
                title: item.metadata.meta_title || item.metadata.title || '',
                description: item.metadata.meta_description || '',
                keywords: item.metadata.meta_keywords || '',
                robots: item.metadata.meta_robots || item.metadata.robots
            },
            ogData: {
                title: item.metadata.og_title || item.metadata.meta_title || item.metadata.title || '',
                description: item.metadata.og_description || item.metadata.meta_description || item.metadata.og_title || item.metadata.meta_title || '',
                image: item.metadata.og_image || null,
                url: item.metadata.og_url || ''
            }
        }));

export { transformCmsBlocksResponse, transformCmsMasterdataContentResponse, transformCmsMenusResponse, transformCmsPagesResponse, transformMasterdataMetadata };
